import {forwardRef, useId} from 'react';
import {classes} from 'utils/style';
import { MONOGRAM_PATHS, MONOGRAM_VIEWBOX } from './paths';
import styles from './Monogram.module.css';

export const Monogram = forwardRef(({highlight, className, ...props}, ref) => {
    const id = useId();
    const clipId = `${id}monogram-clip`;

    return (
        <svg
            aria-hidden
            className={classes(styles.monogram, className)}
            width={MONOGRAM_VIEWBOX.width}
            height={MONOGRAM_VIEWBOX.height}
            viewBox={`0 0 ${MONOGRAM_VIEWBOX.width} ${MONOGRAM_VIEWBOX.height}`}
            ref={ref}
            {...props}
        >
            <defs>
                <clipPath id={clipId}>
                    {MONOGRAM_PATHS.map(d => (
                        <path key={d} d={d}></path>
                    ))}
                </clipPath>
            </defs>
            <rect clipPath={`url(#${clipId})`} width="100%" height="100%"/>
            {highlight && (
                <g clipPath={`url(#${clipId})`}>
                    <rect className={styles.highlight} width="100%" height="100%"/>
                </g>
            )}
        </svg>
    );
});
